<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>

      <v-flex xs12>
        <v-card>
          <v-toolbar
            dark
            color="secondary"
          >
            <v-toolbar-side-icon><v-icon>tune</v-icon></v-toolbar-side-icon>
            <v-toolbar-title>{{$t('general.general')}}</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-layout row wrap align-center>
              <v-flex
                xs12
                md6
              >
                <span>{{$t('general.language')}}</span>
              </v-flex>
              <v-flex
                xs12
                md6
                text-xs-right
              >
                  <v-select
                    :items="languages"
                    @change="changeLanguage"
                    :value="locale"
                    dense
                  ></v-select>
              </v-flex>
              <!-- <v-flex xs12>
                <v-divider></v-divider>
              </v-flex> -->
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-toolbar
            dark
            color="secondary"
          >
            <v-toolbar-side-icon><v-icon>movie</v-icon></v-toolbar-side-icon>
            <v-toolbar-title>{{$t('general.directorFlags')}}</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-layout column wrap align-left>
              <v-flex xs12>
                <v-chip
                  v-bind:key="directorFlag.id"
                  v-for="directorFlag in allDirectorFlags"
                  small
                  close
                  @input="removeDirectorFlag(directorFlag.id)"
                >
                   {{ directorFlag.name }}
                </v-chip>
              </v-flex>

              <v-flex xs12>
                <v-layout row wrap align-center>
                <v-text-field
                  :label="$t('app.newDirectorFlag')"
                  v-model="newDirectorFlagName"
                ></v-text-field>
                <v-btn
                  :disabled="(newDirectorFlagName == '')"
                  color="accent"
                  @click="addNewDirectorFlag();"
                ><v-icon>mdi-plus</v-icon></v-btn>
                </v-layout>

              </v-flex>

            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-toolbar
            dark
            color="secondary"
          >
            <v-toolbar-side-icon><v-icon>person</v-icon></v-toolbar-side-icon>
            <v-toolbar-title>{{$tc('general.account', 1)}}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap align-center>
              <v-flex
                xs12
                md6
              >
                <span>
                  Delete your user account. <b>Be careful. This operation is irreversible!</b>
                </span>
              </v-flex>
              <v-flex
                xs12
                md6
                text-xs-right
              >
                <v-btn
                  color="accent"
                  class="ma-0"
                  @click="deleteModalVisible = true"
                  large
                  dark
                >
                  DELETE
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex
        v-if="
          $store.getters.isSubscriptionUser &&
          $store.getters.hasRole('organization_admin')"
        xs12
      >
        <v-card>
          <v-toolbar
            dark
            color="secondary"
          >
            <v-toolbar-side-icon><v-icon>payment</v-icon></v-toolbar-side-icon>
            <v-toolbar-title>{{$tc('general.subscription', 1)}}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap align-center>
              <v-flex
                xs12
                md6
              >
                <span>
                  Subscription status
                </span>
              </v-flex>
              <v-flex
                xs12
                md6
                text-xs-right
              >
                <span
                  v-if="$store.getters.isSubscriptionUser &&
                  $store.getters.isSubscribed &&
                  !$store.getters.isOnGracePeriod"
                >
                  Subscribed
                </span>
                <span
                  v-else-if="
                    $store.getters.isSubscriptionUser &&
                    $store.getters.isSubscribed &&
                    $store.getters.isOnGracePeriod"
                >
                  Subscribed until
                  <b>{{$store.getters.getProfile.next_billing_date}}</b>.
                  Subscription will be automatically cancelled after this date.
                </span>
                <span
                  v-else
                >
                  Unsbuscribed
                </span>
              </v-flex>
              <v-flex
                v-if="$store.getters.isSubscriptionUser && $store.getters.isSubscribed"
                xs12
                md6
              >
                <span>
                  Subscription charge
                </span>
              </v-flex>
              <v-flex
                v-if="$store.getters.isSubscriptionUser && $store.getters.isSubscribed"
                xs12
                md6
                text-xs-right
              >
                <span>
                  20€ for each registered box
                </span>
              </v-flex>
              <v-flex
                v-if="$store.getters.isSubscriptionUser && $store.getters.isSubscribed"
                xs12
                md6
              >
                <span>
                  Current subscription
                </span>
              </v-flex>
              <v-flex
                v-if="$store.getters.isSubscriptionUser && $store.getters.isSubscribed"
                xs12
                md6
                text-xs-right
              >
                <span>
                  <b>
                    {{$store.getters.getProfile.registered_boxes}} registered boxes =
                    {{$store.getters.getProfile.registered_boxes * 20}}€ monthly
                  </b>
                </span>
              </v-flex>
              <v-flex
                v-if="$store.getters.isSubscriptionUser &&
                  $store.getters.isSubscribed &&
                  !$store.getters.isOnGracePeriod"
                xs12
                md6
              >
                <span>
                  Next billing date
                </span>
              </v-flex>
              <v-flex
                v-if="$store.getters.isSubscriptionUser &&
                $store.getters.isSubscribed &&
                !$store.getters.isOnGracePeriod"
                xs12
                md6
                text-xs-right
              >
                <span>
                  <b>
                    {{$store.getters.getProfile.next_billing_date}}
                  </b>
                </span>
              </v-flex>
              <v-flex
                v-if="$store.getters.isSubscriptionUser && !$store.getters.isSubscribed"
                xs12
                md6
              >
                <span>
                  Subscribe to Tarsius Next (20€ for each registered box)
                </span>
              </v-flex>
              <v-flex
                v-if="$store.getters.isSubscriptionUser && !$store.getters.isSubscribed"
                xs12
                md6
                text-xs-right
              >
                <v-btn
                  color="accent"
                  class="ma-0"
                  @click="subscribeModalVisible = true"
                  large
                  dark
                >
                  Subscribe
                </v-btn>
              </v-flex>
              <v-flex
                v-if="
                  $store.getters.isSubscriptionUser &&
                  $store.getters.isSubscribed &&
                  !$store.getters.isOnGracePeriod"
                xs12
                md6
              >
                <span>
                  Unsubscribe from Tarsius Next
                </span>
              </v-flex>
              <v-flex
                v-if="
                  $store.getters.isSubscriptionUser &&
                  $store.getters.isSubscribed &&
                  !$store.getters.isOnGracePeriod"
                xs12
                md6
                text-xs-right
              >
                <v-btn
                  color="accent"
                  class="ma-0"
                  @click="unsubscribeModalVisible = true"
                  large
                  dark
                >
                  Unsubscribe
                </v-btn>
              </v-flex>
              <v-flex
                v-if="
                  $store.getters.isSubscriptionUser &&
                  $store.getters.isSubscribed &&
                  $store.getters.isOnGracePeriod"
                xs12
                md6
              >
                <span>
                    Resume your subscription
                </span>
              </v-flex>
              <v-flex
                v-if="
                  $store.getters.isSubscriptionUser &&
                  $store.getters.isSubscribed &&
                  $store.getters.isOnGracePeriod"
                xs12
                md6
                text-xs-right
              >
                <v-btn
                  color="accent"
                  class="ma-0"
                  @click="resumeSubscriptionModalVisible = true"
                  large
                  dark
                >
                  Resume
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex
        v-if="
          $store.getters.isSubscriptionUser &&
          $store.getters.hasRole('organization_admin')"
        xs12
      >
        <v-card>
          <v-toolbar
            color="secondary"
            dark
          >
            <v-toolbar-side-icon><v-icon>attach_money</v-icon></v-toolbar-side-icon>
            <v-toolbar-title>{{$tc('settings.invoice', 2)}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              type="text"
              v-model="filterText"
              @keyup.enter="doFilter"
              :placeholder="$t('settings.invoicesFilterPlaceholder')"
              single-line
              hide-details
            ></v-text-field>
            <v-btn
              @click.prevent="doFilter"
              icon
            >
              <v-icon>search</v-icon>
            </v-btn>

            <v-btn
              @click.prevent="resetFilter"
              icon
            >
              <v-icon>restore</v-icon>
            </v-btn>
            <transition
              enter-active-class="animated bounceIn"
              leave-active-class="animated bounceOut"
            >
              <v-btn
                v-if="selectedRows !== undefined && selectedRows.length !== 0"
                @click.prevent="massDeleteModalVisible = true"
                icon
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </transition>
          </v-toolbar>
          <v-card-text>
            <v-progress-linear
              v-show="loading"
              slot="progress"
              color="accent"
              indeterminate
            ></v-progress-linear>

            <vuetable
              ref="vuetable"
              data-path="data"
              pagination-path="meta"
              track-by="id"
              :api-url="`${this.apiUrl}api/subscription/invoices`"
              :http-fetch="httpFetch"
              :fields="fields"
              :css="css.table"
              :sort-order="sortOrder"
              :multi-sort="true"
              :append-params="moreParams"
              @vuetable:pagination-data="onPaginationData"
              @vuetable:loading="onLoading"
              @vuetable:loaded="onLoaded"
            >
              <div slot="actions-slot" slot-scope="props">
                <v-btn
                  @click.native="downloadInvoice(props.rowData)"
                  flat
                  icon
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </div>
            </vuetable>
          </v-card-text>
          <v-card-actions>
            <vuetable-pagination ref="pagination"
              :css="css.pagination"
              @vuetable-pagination:change-page="onChangePage"
            ></vuetable-pagination>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="deleteModalVisible"
      width="500"
    >
      <v-card>
        <v-card-text>
          <p>
            Are you really sure you want to delete your user account?
            This process is <b>dangerous</b> and <b>irreversible</b>.
            If you want to continue, please insert your password to confirm your identity.
          </p>
          <v-text-field
            v-model="password"
            name="password"
            type="password"
            :label="$t('auth.password')"
            prepend-icon="lock"
            required
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="deleteModalVisible = false"
            color="accent"
            flat
            dark
          >
            {{ $t('general.cancel') }}
          </v-btn>
          <v-btn
            @click="deleteUserAccount"
            color="accent"
            dark
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="subscribeModalVisible"
      width="500"
    >
      <subscription-dialog-dropin
        :collect-card-holder-name="true"
        :collect-postal-code="false"
        :enable-data-collector="false"
        :enable-paypal="true"
      ></subscription-dialog-dropin>
    </v-dialog>

    <v-dialog
      v-model="unsubscribeModalVisible"
      width="500"
    >
      <v-card>
        <v-card-text>
          <p>
            Are you really sure you want to unsubscribe?
            This will disable your access to customizing boxes.
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="unsubscribeModalVisible = false"
            color="accent"
            flat
            dark
          >
            {{ $t('general.cancel') }}
          </v-btn>
          <v-btn
            @click="cancelSubscription"
            color="accent"
            dark
          >
            Unsubscribe
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="resumeSubscriptionModalVisible"
      width="500"
    >
      <v-card>
        <v-card-text>
          <p>
            Are you really sure you want to resume your subscription?
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="resumeSubscriptionModalVisible = false"
            color="accent"
            flat
            dark
          >
            {{ $t('general.cancel') }}
          </v-btn>
          <v-btn
            @click="resumeSubscription"
            color="accent"
            dark
          >
            Resume
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios';
import VueTableMixin from '@/components/generic/VueTableMixin';
import loadLanguageAsync from '@/main';
import { AUTH_LOGOUT } from '@/store/actions/auth';
import { USER_REQUEST } from '@/store/actions/user';
import SubscriptionDialogDropin from './SubscriptionDialogDropin.vue';

export default {
  name: 'settings',
  mixins: [
    VueTableMixin,
  ],
  components: {
    SubscriptionDialogDropin,
  },
  computed: {
    locale: {
      get() {
        return localStorage.getItem('locale');
      },
    },
    languages: {
      get() {
        return [
          { text: this.$i18n.t('general.english'), value: 'en' },
          { text: this.$i18n.t('general.slovak'), value: 'sk' },
        ];
      },
    },
  },
  data() {
    return {
      apiUrl: window.api_url,
      deleteModalVisible: false,
      subscribeModalVisible: false,
      unsubscribeModalVisible: false,
      resumeSubscriptionModalVisible: false,
      password: null,
      fields: [
        {
          name: 'id',
          title: 'ID',
          sortField: 'id',
          titleClass: 'text-xs-left',
          dataClass: 'text-xs-left',
        },
        {
          name: 'amount',
          title: this.$i18n.t('settings.amount'),
          sortField: 'amount',
          titleClass: 'text-xs-left',
          dataClass: 'text-xs-left',
        },
        {
          name: 'date',
          title: this.$i18n.t('settings.date'),
          sortField: 'date',
          titleClass: 'text-xs-left',
          dataClass: 'text-xs-left',
        },
        {
          name: 'actions-slot',
          title: this.$i18n.tc('general.action', 2),
          titleClass: 'text-xs-center',
          dataClass: 'text-xs-center',
        },
      ],
      css: {
        table: {
          tableClass: 'v-table v-datatable',
          ascendingIcon: 'mdi mdi-sort-ascending',
          descendingIcon: 'mdi mdi-sort-descending',
        },
      },
      sortOrder: [
        { field: 'date', sortField: 'date', direction: 'asc' },
      ],
      allDirectorFlags: [],
      newDirectorFlagName: '',
    };
  },
  mounted() {
    this.$store.dispatch(USER_REQUEST);
    this.getAllDirectorFlags();
  },
  methods: {
    changeLanguage(locale) {
      localStorage.setItem('locale', locale);
      loadLanguageAsync(locale);
    },
    deleteUserAccount() {
      const vm = this;
      const userDetails = {
        data: {
          password: this.password,
        },
      };

      this.deleteModalVisible = false;

      axios.delete(`${this.apiUrl}api/user`, userDetails)
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
          vm.$store.dispatch(AUTH_LOGOUT)
            .then(() => {
              this.$router.push('/');
            });
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    downloadInvoice(transaction) {
      const vm = this;

      axios.get(`${this.apiUrl}api/subscription/invoice/${transaction.id}`, {
        responseType: 'blob',
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', `invoice-tarsius-${transaction.id}.pdf`);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    cancelSubscription() {
      const vm = this;

      this.unsubscribeModalVisible = false;

      axios.get(`${this.apiUrl}api/subscription/cancel`)
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
          vm.$store.dispatch(USER_REQUEST);
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    resumeSubscription() {
      const vm = this;

      this.resumeSubscriptionModalVisible = false;

      axios.get(`${this.apiUrl}api/subscription/resume`)
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
          vm.$store.dispatch(USER_REQUEST);
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
    getAllDirectorFlags() {
      const vm = this;
      axios.get(`${window.api_url}api/director-flags`, {
        params: {
          paginate: false,
        },
      })
        .then((response) => {
          vm.allDirectorFlags = response.data.data;
        });
    },
    addNewDirectorFlag() {
      const vm = this;
      if (this.newDirectorFlagName === '') return;
      // eslint-disable-next-line max-len
      const found = this.allDirectorFlags.find((element) => element.name === this.newDirectorFlagName);
      if (typeof (found) !== 'undefined') return;
      axios.post(`${this.apiUrl}api/director-flag`, {
        name: this.newDirectorFlagName,
      })
        .then((response) => { // eslint-disable-line no-unused-vars
          vm.getAllDirectorFlags();
        });
    },
    removeDirectorFlag(id) {
      const vm = this;
      axios.delete(`${this.apiUrl}api/director-flag/${id}`, {})
        .then((response) => { // eslint-disable-line no-unused-vars
          vm.getAllDirectorFlags();
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
  },
};
</script>
